// A small version of a guide or place cover, for cards and rows (2026-11-04): the Library's Featured cards
// (96 px) loaded every guide's main cover — a 1280 px Wikimedia or 1200 px Andiamo photo, 100–400 KB each —
// for ~770 guides at once. Prefers the thumbnail field, else shrinks a known large link:
//   Wikimedia ".../1280px-X.jpg" → ".../330px-X.jpg" (a standard Commons width)
//   our "X_w1200.jpg" → "X_w320.jpg"
// Anything else is returned as it is.
export function smallCover(thumb, main) {
  const src = thumb || main || "";
  if (/wikimedia\.org\/.*\/(960|1280|1920)px-/.test(src)) return src.replace(/\/(960|1280|1920)px-/, "/330px-");
  if (/andiamotravelapp\.com\/Images\/.*_w1200\.jpg$/.test(src)) return src.replace(/_w1200\.jpg$/, "_w320.jpg");
  return src;
}
